import React from 'react'

import audioIcon from '../../assets/audio.svg'
import sendIcon from '../../assets/send.svg'
import stopIcon from '../../assets/stop.svg'
import uploadIcon from '../../assets/upload.svg'
import videoIcon from '../../assets/video.svg'
import type { ActionType } from './ActionButto.types'
import * as S from './ActionButton.styled'
import { BUTTON_SIZE, STROKE_WIDTH } from './consts'

const radius = BUTTON_SIZE / 2 - STROKE_WIDTH / 2
const cx = BUTTON_SIZE / 2
const cy = BUTTON_SIZE / 2

export type ActionButtonProps = {
  actionType: ActionType
  onClick?: () => void
}

export const ActionButton = ({ actionType, onClick }: ActionButtonProps) => {
  const iconSrc = {
    video: videoIcon,
    audio: audioIcon,
    photo: undefined,
    upload: uploadIcon,
    stop: stopIcon,
    send: sendIcon,
  }[actionType]

  return (
    <S.Container actionType={actionType} onClick={onClick}>
      {iconSrc && <img src={iconSrc} />}
      {actionType === 'photo' && (
        <>
          <S.StaticRing />
          <S.InnerCircle />
        </>
      )}
      {actionType === 'stop' && (
        <S.ProgressRing viewBox={`0 0 ${BUTTON_SIZE} ${BUTTON_SIZE}`}>
          <S.BackgroundCircle r={radius} cx={cx} cy={cy} />
          <S.Circle circumference={radius * 2 * Math.PI} r={radius} cx={cx} cy={cy} />
        </S.ProgressRing>
      )}
    </S.Container>
  )
}
